var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tank.cooler_id)?_c('menu-item',{attrs:{"label":"","tooltip-key":"tooltip_cooler"}},[_c('custom-checkbox',{attrs:{"label":_vm.$t('powerpack.valveMenu.cooler')},model:{value:(_vm.cooler),callback:function ($$v) {_vm.cooler=$$v},expression:"cooler"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }